import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setMall, setProjectName } from "../redux/appReducer";
import Services from "../services/Services";
import { encrypt } from "../utils/encrypt";
import { CircularProgress, Box } from "@mui/material";

export default function ProcessByCodePage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const uri = searchParams.get("uri");
  const hashedCode = localStorage.getItem("hashedCode");

  useEffect(() => {
    Services.GetDefaultToken()
      .then((res) => {
        const token = res.data.result.token;
        localStorage.setItem("token", token);

        const proceedAfterMall = () => {
          const controlPhone =
            localStorage.getItem("phone") || localStorage.getItem("email");
          if (
            controlPhone &&
            encrypt(controlPhone, "handsfreeAvm*24") == hashedCode
          ) {
            navigate("/code-form", { state: { code, fromCode: true } });
          } else {
            if (code) localStorage.setItem("pendingCode", code);
            navigate("/login");
          }
        };

        if (uri) {
          const normalizedUri =
            uri === "the-lands-of-legends" ? "the-land-of-legends" : uri;
          localStorage.setItem("mallUri", normalizedUri);
          if (normalizedUri === "galataport") {
            dispatch(setProjectName("Bags-Free"));
            dispatch(setMall("galataport"));
          } else {
            dispatch(setProjectName("Hands Free"));
            dispatch(setMall("default"));
          }
          Services.GetMallToken(token, normalizedUri)
            .then((response) => {
              localStorage.setItem(
                "mall",
                JSON.stringify(response?.data?.result?.mall),
              );
            })
            .catch(() => {
              localStorage.setItem("mall", JSON.stringify(""));
            })
            .finally(() => {
              proceedAfterMall();
            });
        } else {
          proceedAfterMall();
        }
      })
      .catch(() => {
        navigate("/login");
      });
  }, []);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress color="primary" />
    </Box>
  );
}
